import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const usePageTitle = (title: string) => {
    const location = useLocation();

    useEffect(() => {
        const envProjectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;
        const envSuffix = envProjectId === 'fg2p-test' ? ' - TEST' : '';
        document.title = `${title} - fg2p${envSuffix}`;
    }, [title, location]);
};

export default usePageTitle; 